<template>
	<div class="footers">
		<footer class="main-footer">
			<div class="row">
				<div class="columns column3">
					<div class="footer-logo" />
				</div>
				<div class="columns column3">
					<h4>{{ $t('address') }}</h4>
					<p class="address">
						<span>{{ defaults[locale].website.restaurantName }}</span>
						<span>{{ defaults[locale].website.street }} {{ defaults[locale].website.number }}</span>
						<span>{{ defaults[locale].website.postalCode }} {{ defaults[locale].website.city }}</span>
						<span>{{ defaults[locale].website.country }}</span>
					</p>
				</div>
				<div class="columns column3">
					<h4>{{ $t('contact') }}</h4>
					<p>
						<a :href="`tel:${$phoneRaw(defaults[locale].website.phone)}`" class="contact-link">
							<font-awesome-icon :icon="`fal fa-phone`" size="1x" />
							<span>{{ defaults[locale].website.phone }}</span>
						</a>
						<a :href="`mailto:${defaults[locale].website.email}`" class="contact-link">
							<font-awesome-icon :icon="`fal fa-envelope`" size="1x" />
							<span>{{ defaults[locale].website.email }}</span>
						</a>
					</p>
					<social-media :socials="socials" />
				</div>
				<div class="columns column3">
					<h4>{{ $t('quickLinks') }}</h4>
					<p>
						<nuxt-link v-for="item in footermenu[locale]" :key="item.filename" :to="item.filename">
							{{ item.header }}
						</nuxt-link>
					</p>
				</div>
			</div>
		</footer>
		<footer class="author-footer">
			<div class="row">
				<div class="columns column12">
					<div class="border" />
					<p>
						<a
							href="https://www.becurious.com/"
							target="_blank"
							rel="noopener noreferrer"
							title="Hotel website design by becurious"
						>
							Website Design
						</a>
						<span>by:</span>
						<a href="https://www.becurious.com/" target="_blank">
							<img src="~/assets/images/logo-becurious-white.png" loading="lazy" alt="Porter logo" />
						</a>
					</p>
				</div>
			</div>
		</footer>
	</div>
</template>

<script setup>
const { data: footer } = await useWebsiteFetch('footermenu');
const { footermenu } = footer.value;
const { locale } = useI18n();

const { defaults, socials, fetchDefaults } = useDefaults();

if (!defaults.value) {
	await fetchDefaults();
}
</script>

<style lang="scss" scoped>
.footers {
	color: #fff;
	background: var(--footer-background-color);

	a,
	span {
		color: var(--footer-color);
		text-decoration: none;
	}

	h3,
	h4 {
		color: var(--footer-color);
		letter-spacing: 1px;
	}

	h4 {
		font-family: var(--body-font-family);
		font-size: 1.3em;
	}
}

.main-footer {
	padding: 75px 0;
	font-size: 16px;

	.contact-link {
		display: flex;
		flex-flow: row nowrap;
		justify-content: flex-start;
		align-items: center;
		gap: 15px;
		transition: all 0.3s ease-in-out;

		svg {
			transition: all 0.3s ease-in-out;
		}

		&:hover {
			svg {
				color: var(--cta-color);
			}
		}
	}

	.footer-logo {
		padding: 0;
		margin: 0 0 20px;
		text-decoration: none;
		width: 150px;
		height: 80px;
		background: url('~/assets/images/logo-donfoodandevents-white-full.png') no-repeat center center;
		background-size: 150px;
	}

	p {
		font-size: 0.9em;
	}

	a,
	span {
		display: block;
	}

	a:hover {
		text-decoration: underline;
	}
}

.author-footer {
	font-size: 0.8em;
	padding: 5px 0;
	text-align: center;
	width: 100%;

	p {
		margin: 15px 0;
	}

	.border {
		background: rgb(255 255 255 / 6%);
		width: 100%;
		height: 1px;
	}

	img {
		max-width: 90px;
		margin: -2px 1px 4px 6px;
	}
}

@media (max-width: 1080px) {
	footer .columns {
		margin: 0 auto 20px;
	}
}

@media (max-width: 640px) {
	.main-footer {
		padding: 30px 5px;
		text-align: center;

		.contact-link {
			justify-content: center;
		}

		.footer-logo {
			margin: 0 auto 20px;
		}
	}
}
</style>
